module.exports = __webpack_public_path__ + "static/WhenThePastWasAround3-e50905a4b16d5d80988b62d814288218.webp";